'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _base = require('./base');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {
  appEnv: 'production', // feel free to remove the appEnv property here
  stripe_key: 'pk_live_piH50bk7ujXQrWfJtzKS5BCa',
  stripe_keys: {
    calgary: 'pk_live_51HFhRuJXPNwcKmifrEAdCKeTvMcG1R17LfFgYf8heO5ymkeYQcuha8X5tZHIpuldA3whe9OyflKtWtmvQ4tM8Is80080pNqSaO',
    toronto: 'pk_live_piH50bk7ujXQrWfJtzKS5BCa',
    rimisecureadvantageplus: 'pk_live_51T7HjBE3dmn5hjf95iGyKE29ejNhphRfNdWdZawGBNt4yfT8uLvfxXBKegy4TZ0WP0eC6XGADDsLnT6CyQo3r6ga00foCt1Fcr'
  },
  api: 'https://auth.policy-dashboard.com/api/travel/insurance/public',
  auth_api: 'https://auth.policy-dashboard.com/token/travel/insurance/public',
  msh_api: 'https://auth.policy-dashboard.com/api/msh/insurance',
  msh_auth_api: 'https://auth.policy-dashboard.com/token/msh/insurance/public',
  sentry: 'https://d1b9ec5f0882474399527949ff8e74be@sentry.io/139843',
  version: '20221212'
};

exports.default = Object.freeze(_extends({}, _base2.default, config));


//////////////////
// WEBPACK FOOTER
// ./src/config/prod.js
// module id = 66
// module chunks = 0